var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      on: {
        click: function($event) {
          return _vm.optimizelyClick($event)
        }
      }
    },
    [
      !_vm.isOptimizelyVariation && !_vm.forceAlwaysOn
        ? _c("button", { class: _vm.className, attrs: { id: _vm.id } }, [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n  ")
          ])
        : _c(
            "lightbox-button",
            {
              class: [_vm.className, _vm.className + "--optimizely"],
              attrs: {
                target: _vm.target,
                id: _vm.id,
                "optimizely-prefix": _vm.optimizelyPrefix,
                prefix: _vm.prefix
              }
            },
            [_vm._v(_vm._s(_vm.label))]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }